export const WorkshopSearchTypes = Object.freeze({
    "MAINTENANCE": "Mantenimiento",
    "FAILURE": "Averia",
    "TYRES": "Neumaticos",
    "SMR": "SMR"
    })